import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { NbAuthService, NbAuthToken, NbTokenService } from "@nebular/auth";
import { switchMap } from "rxjs/operators";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  token$: Observable<NbAuthToken>;
  token: string;

  constructor(
    private tokenService: NbTokenService,
    private authService: NbAuthService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.authService.getToken().pipe(
      switchMap((token: NbAuthToken) => {
        const authReq = req.clone({
          headers: req.headers.set(
            "Authorization",
            `Bearer ${token.getValue()}`
          ),
        });
        return next.handle(authReq);
      })
    );
  }
}

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
];
